define('views/components/FormView',[
    'evertrue',
    'jquery',
    'underscore',
    'backbone',
    'ET/ETView',
    'form',
    'datepicker',
    'bootstrapTour'
], function FormViewFactory ( EverTrue, $, _, Backbone, ETView) {

    var FormView = ETView.extend({

        tagName: this.tagName || "div",
        className : this.className || "et-form",
        collection : this.collection || "",
        typeClassMap : {
            'success' : 'text-success',
            'error' : 'text-error',
            'info' : 'text-info'
        },
        events : {
            'submit form' : 'submitForm',
            'change input[data-data-type="image"]' : 'getImagePreview'
        },
        initialize : function (options) {
            // set progress, success, and error indicators
            this.setSubmitButtonListeners();

            // bootstrap form data
            this.formObj = this.formObj || this.options.formObj || {};
            this.formObj = (this.defaults) ? this.defaults : this.formObj;
            // prevent autorendering if {render : false} passed in
            if (this.options.render !== false){
                this.render();
            }
        },
        setSubmitButtonListeners : function(){
            var view = this;

            this.on('error', function(resp){
                view.displaySavingStateIndicator(2);
            });
            this.on('success', function(resp){
                view.displaySavingStateIndicator(2);
                // show success
                EverTrue.alertView.alert("success", {header: "Success", message: "Form Saved"});
            });
            this.on('request', function(resp){
                // change the save button to show we are saving...
                view.displaySavingStateIndicator(1);
            });
        },
        translateModelKeysToFormValues : function (model, formData, direction){
            var newModObj = {};
            modelObj = (model instanceof Backbone.Model) ? model.toJSON() : model;
            // if direction is true we are translating from the model to the form
            if (direction){
                // loop through the format we want, extract the data from model and put it in the val
                _.each(formData, function(data){
                    var key = data.referenceKey || data.key;
                    if (key){
                        var value = EverTrue.useValueFromVariableKeyWithDotNotation(key, modelObj) || data.value_override;
                        // select boxes, need to match
                        if (data.select){
                            _.each(data.select, function(sel){
                                // just use == to account for number/string matches
                                sel.selected = (sel.val == value);
                            });
                        }
                        // radio buttons need to match
                        if (data.buttons){
                            _.each(data.buttons, function(sel){
                                sel.checked = (sel.val == value);
                            });
                        }
                        else{
                            data.val = value;
                        }
                    }
                });
            }
            // otherwise we are translating from the form to the value
            else{
                _.each(formData, function(val, key){
                    // extract the base key
                    baseKey = key.split('.')[0];
                    // set the root dna key val pair
                    newModObj[baseKey] = modelObj[baseKey];
                    // set the new dna value
                    EverTrue.useValueFromVariableKeyWithDotNotation(key,newModObj,val);
                });
            }
            return newModObj;
        },
        // sync model with form
        bindModelToForm: function(data) {
            var view = this;
            var mod = data || this.model;
            // bootstrap the model with data from dna
            if(this.formObj.fieldset){
                var fieldset = [];
                if (_.isArray(this.formObj.fieldset)){
                    fieldset = this.formObj.fieldset;
                }
                else{
                    fieldset.push(this.formObj.fieldset);
                }
                _.each(fieldset, function(d, key){
                    view.translateModelKeysToFormValues(mod, d.formElements, true);
                });
            }
        },
        displaySavingStateIndicator : function(step, text){
            // text map
            var textMap = {
                'Save' : {
                    1 : 'Saving...',
                    2 : 'Saved'
                },
                'Submit' : {
                    1 : 'Submitting...',
                    2 : 'Submitted'
                },
                'Start Import' : {
                    1 : 'Starting Import...',
                    2 : 'Import Started'
                }
            };

            // find the save button for this form
            var $saveButton = this.$('[type="submit"]'),
            view = this;

            if(step === 1) {
                this.origVal = this.origVal || $saveButton.val();
                var btnType = textMap[this.origVal];
                if (btnType && btnType[step]){
                    // disable and change the text to saving
                    $saveButton.val(textMap[this.origVal][step]).prop('disabled', true);
                }
                return;
            }
            else if (step === 2){
                // change the class and the text to indicate the form has been saved
                $saveButton.val(textMap[this.origVal][step]);
                // switch back to the save button
                setTimeout(function(){
                    $saveButton.val(view.origVal).prop('disabled', false);
                }, 1000);
            }
        },
        toggleFormElement : function(key, showOrHide){
            // get jquery el
            $formEl = (key instanceof jQuery) ? key : $('[name="' + key + '"]');
            // disable/enable
            $formEl.attr('disabled', !showOrHide);
            // hide/show
            $formEl.parents('.input-container').toggleClass('hidden', !showOrHide);
            // turn this on or off with parsley
            var parsleyMethod = (showOrHide) ? 'addItem' : 'removeItem';
            this.$form.parsley( parsleyMethod, $formEl );
        },
        addDisplayItem : function (key, msg, type, id){
            var typeClass = 'et-'+ type +'-list';
            var className = this.typeClassMap[type];

            if(id){
                $id = $('[data-id="'+ id +'"]');
                if ($id.length){
                    $id.removeClass().addClass(className + ' help-block').text(msg);
                    return $id;
                }
            }
            else{
                id = '';
            }

            // get jquery el
            $formEl = (key instanceof jQuery) ? key : this.$('[name="' + key + '"]');

            $displayContainer = $formEl.next(typeClass);
            if (!$displayContainer.length){
                $displayContainer = $('<span class="'+ typeClass + '"></span>');
                $formEl.after($displayContainer);
            }
            // create the item
            $displayItem = $('<span data-id="' +id +'" class="help-block '+ type +' ' + className +'">'+ msg +'</span>');
            $displayContainer.append($displayItem);

            // return the created item
            return $displayItem;
        },
        removeDisplayItem : function(id){
            $('[data-id="'+ id +'"]').remove();
        },
        submitForm : function (e) {
            // stop the default submit event
            e.preventDefault();

            var $target = $(e.target);
            // get the suggested_updates data
            var formData = $target.serializeObject();
            // account for checkboxes
            $target.find('input[type=checkbox]').each(function(ind,el){
                formData[el.name] = (el.checked) ?  1 : 0;
            });
            var valid = this.validate();
            if (!valid) return false;

            if (this.ignoreFormData) formData = _.omit( formData, this.ignoreFormData);
            if (this.hiddenFormData){
                _.extend(formData, this.hiddenFormData);
            }

            if (this.model){
                // only send the attributes that have changed
                if (this.model.changedAttributes) {
                    formData = this.model.changedAttributes(formData);
                }
            }

            // either respond with a custom submit handler or default to posting to our api
            if(_.isFunction(this.onFormSubmit) ){
                this.onFormSubmit(formData, e, this);
            }
            else if (this.apiEndpoint){
                var options = {
                    url : this.apiEndpoint,
                    data : formData,
                    type : 'POST'
                };
                EverTrue.api(options, this);
            }
        },
        // Preview uploaded image
        getImagePreview: function(e){
            var input = e.target;
            $target = $(input);
            $previewContainer = this.$('.image-container.preview');
            // Check for the various File API support.
            if (window.File && window.FileReader && window.FileList && window.Blob) {
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    reader.onload = function (ev) {
                        var result = ev.target.result;
                        // placeholder is either a font-awesome icon or the previously uploaded preview
                        // replace the placeholder with the selected preview image
                        $previewContainer.children('i, img').replaceWith('<img id="img-preview" src="'+ result +'">');
                    };
                    reader.readAsDataURL(input.files[0]);
                }
                // The user did not choose a file
                else{
                    $previewContainer.children('i, img').replaceWith('<i class="icon-picture"></i>');
                }
            } else {
                // Error feedback for picky browsers
                $previewContainer.text('Image previews are not fully supported in this browser.');
            }
        },
        render: function(done){
            var view = this;

            if (this.model){
                this.bindModelToForm();
            }
            view.formObj.timestamp = new Date().getTime();
            var tmpl = this.tmpl || 'FormDefault.html';
            EverTrue.fetchTemplate( tmpl, function (name) {
                dust.render( name, view.formObj, function (err, out) {
                    // first time rendering replace this.$el with the output
                    if (view.formObj.modal){
                        if (!view.renderedOnce)
                        {
                            view.setElement('<div class="modal hide fade" id="' + view.formObj.modal + '">' + out + '</div>');
                            view.renderedOnce = true;
                        }
                        else
                        {
                            view.$el.html(out);
                        }
                    }
                    else{
                        view.$el.html(out);
                    }
                    if (_.isFunction(done)){
                        done();
                    }
                    view.initializePlugins(view.collection);
                });
            });
            return this;
        }

    });

    return FormView;
});

